<script>
import MetisMenu from 'metismenujs/dist/metismenujs'

import { authComputed } from '@state/helpers'
import { authProtectedRoutes, adminRoute } from '@routes'
import { mapGetters } from 'vuex'
// import axios from 'axios';

/**
 * Application menu component
 */
export default {
  filters: {
    renameMenu(menu) {
      let renamed = menu.replace('admin_', '')
      renamed = renamed.replace('_', '')
      return renamed
    },
  },
  props: {
    mode: {
      type: String,
      default: 'horizontal',
    },
  },
  data() {
    return {
      menuItems: authProtectedRoutes,
      adminMenus: adminRoute,
      hidiedAdminMenus: [],
      hidiedAuthMenus: [],
      showAdminMenus: [
        'admin_Dashboard',
        'admin_Activity',
        'admin_Security',
        'admin_Send SMS',
        'admin_SMPP & API',
        'admin_Sender',
        'admin_Routing',
        'admin_Options',
        'admin_SMS Gateway',
        'admin_IP Verification',
        'admin_Announcement',
      ],
      showAuthMenus: [
        'Dashboard',
        'Activity',
        'Send SMS',
        'SMPP & API',
        'Sender',
        'SMS Gateway',
        'IP Verification',
        'Announcement',
      ],
      notifications: [],
    }
  },
  computed: {
    ...authComputed,
    ...mapGetters('auth', ['isSubAccount', 'currentUser']),
  },
  watch: {
    notifications: function(newValue, oldValue) {
      if (this.notifications.length < 1) return false
      newValue.forEach((notification) => {
        this.$toastr.Add({
          title: notification.title ? notification.title : '',
          msg: notification.message,
          onCreated: () => {
            this.$store.dispatch(
              'notification/removeNotification',
              notification,
              { root: true }
            )
          },
          type: notification.type ? notification.type : 'info',
        })
      })
    },
  },
  created() {
    this.hidiedAdminMenus = this.adminMenus[0].children.filter((value) =>
      this.showAdminMenus.includes(value.name)
    )

    this.hidiedAuthMenus = this.menuItems.filter((value) =>
      this.showAuthMenus.includes(value.name)
    )

    // Hide and show menu by product
    this.hidiedAuthMenus = this.hidiedAuthMenus.filter((value) => {
      if (!value.meta.hasOwnProperty('product')) {
        return true
      } else {
        let show = false
        this.currentUser.subscriptions.forEach((item) => {
          if (item === value.meta.product) {
            show = true
          }
          else if (item === null) {
            show = false
            return show
          }
        })
        return show
      }
    })

    // Hide and show SMPP & API menu by product
    this.hidiedAuthMenus.forEach((element, index) => {
      if (element.name === 'SMPP & API') {
        this.hidiedAuthMenus[index].children = element.children.filter(
          (child) => {
            let show = false
            this.currentUser.subscriptions.forEach((item) => {
              if (item === child.meta.product) {
                show = true
              }
            })
            return show
          }
        )
        if (this.hidiedAuthMenus[index].children.length === 0)
          this.hidiedAuthMenus.splice(index, 1)
      }
    })

    let _this = this
    this.$store.watch(
      function(state) {
        return state.notification.notifications
      },
      function() {
        _this.notifications =
          _this.$store.getters['notification/allNotifications']
      },
      { deep: true }
    )
  },
  mounted: function() {
    this.notification = this.$store.getters['notification/allNotifications']
    // eslint-disable-next-line no-unused-vars
    var menuRef = null
    if (this.mode === 'horizontal') {
      menuRef = new MetisMenu('#side-menu').on('shown.metisMenu', function(
        event
      ) {
        window.addEventListener('click', function menuClick(e) {
          if (!event.target.contains(e.target)) {
            menuRef.hide(event.detail.shownElement)
            window.removeEventListener('click', menuClick)
          }
        })
      })
    } else {
      menuRef = new MetisMenu('#side-menu')
    }

    var links = document.getElementsByClassName('side-nav-link-ref')
    var matchingMenuItem = null
    // let menuItemEl = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    const activeClass = this.mode === 'horizontal' ? 'active' : 'mm-active'
    const dropdownActiveClass =
      this.mode === 'horizontal' ? 'active' : 'mm-show'
    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add(activeClass)
        const parent2 = parent.parentElement
        if (parent2) {
          parent2.classList.add(dropdownActiveClass)
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add(activeClass)
          if (parent3.childNodes[1]) {
            parent3.childNodes[1].classList.add('active')
            parent3.childNodes[3].classList.add('mm-show')
          }
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4) parent4.classList.add(dropdownActiveClass)
        const parent5 = parent4.parentElement
        if (parent5) parent5.classList.add(activeClass)
      }
    }
  },
  methods: {
    hasItems(item) {
      return item && item.children !== undefined
        ? item.children.length > 0
        : false
    },
    isInvalidMenu(item) {
      let hiddenMenus = ['Account', 'Billing']
      let invalid = false
      if (this.isSubAccount & hiddenMenus.includes(item.name)) {
        invalid = true
      }
      return invalid
    },
    isParentRequired(meta) {
      let required = false
      if (meta.hasOwnProperty('parentRequired')) {
        required = meta.parentRequired
      }
      return required
    },
  },
}
</script>

<template>
  <ul v-if="isAdmin" id="side-menu" class="metismenu">
    <li
      v-for="item in hidiedAdminMenus"
      :key="`item-${item.name}`"
      class="side-nav-title side-nav-item"
    >
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <a v-if="hasItems(item)" href="javascript:void(0);" class="side-nav-link">
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name | renameMenu }}</span>
        <span class="menu-arrow"></span>
      </a>
      <router-link
        v-if="!hasItems(item)"
        tag="a"
        :to="{ name: item.name }"
        class="side-nav-link side-nav-link-ref"
      >
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name | renameMenu }}</span>
        <span
          v-if="item.badge"
          :class="
            'badge badge-' + item.badge.varient + ' float-right font-size-11'
          "
          >{{ item.badge.text }}</span
        >
      </router-link>

      <ul v-if="hasItems(item)" class="nav-second-level">
        <template v-for="subitem in item.children">
          <li
            v-if="subitem.path !== 'profile'"
            :key="`sub-item-${subitem.name}`"
            :class="{ 'side-nav-item': hasItems(subitem) }"
          >
            <a
              v-if="hasItems(subitem)"
              href="javascript:void(0);"
              class="side-nav-link-a-ref"
            >
              {{ subitem.name }}
              <span class="menu-arrow"></span>
            </a>
            <router-link
              v-if="!hasItems(subitem)"
              tag="a"
              :to="{ name: subitem.name }"
              class="side-nav-link-ref"
              >{{ subitem.name | renameMenu }}</router-link
            >

            <ul
              v-if="hasItems(subitem)"
              class="nav-third-level"
              aria-expanded="false"
            >
              <li
                v-for="subSubitem in subitem.children"
                :key="`sub-sub-item-${subSubitem.name}`"
              >
                <router-link
                  tag="a"
                  :to="{ name: subSubitem.name }"
                  class="side-nav-link-ref"
                  >{{ subSubitem.name | renameMenu }}</router-link
                >
              </li>
            </ul>
          </li>
        </template>
      </ul>
    </li>
    <li class="side-nav-title side-nav-item">
      <p class="menu-title mb-0">Support</p>
      <router-link
        tag="a"
        :to="{ name: 'Support' }"
        class="side-nav-link side-nav-link-ref"
      >
        <i class="mr-2 uil uil-question-circle"></i>
        <span>API & Doc</span>
      </router-link>
    </li>
  </ul>
  <!--- Sidemenu -->
  <ul v-else id="side-menu" class="metismenu">
    <template v-for="item in hidiedAuthMenus">
      <li
        v-if="isSubAccount !== isParentRequired(item.meta) || !isSubAccount"
        :key="`item-${item.name}`"
        class="side-nav-title side-nav-item"
      >
        <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>
        <a
          v-if="hasItems(item)"
          href="javascript:void(0);"
          class="side-nav-link"
          :class="{ 'd-none': isInvalidMenu(item) }"
        >
          <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
          <span>{{ item.name }}</span>
          <span class="menu-arrow"></span>
        </a>

        <router-link
          v-if="!hasItems(item)"
          tag="a"
          :to="`${item.path}`"
          class="nav-link side-nav-link-ref"
        >
          <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
          <span>{{ item.name }}</span>
          <span
            v-if="item.badge"
            :class="
              'badge badge-' + item.badge.varient + ' float-right font-size-11'
            "
            >{{ item.badge.text }}</span
          >
        </router-link>

        <ul v-if="hasItems(item)" class="nav-second-level">
          <template v-for="subitem in item.children">
            <li
              v-if="
                (isSubAccount !== isParentRequired(subitem.meta) ||
                  !isSubAccount) &&
                  subitem.name !== 'Profile'
              "
              :key="`sub-item-${subitem.name}`"
              :class="{ 'side-nav-item': hasItems(subitem) }"
            >
              <a
                v-if="hasItems(subitem)"
                href="javascript:void(0);"
                class="side-nav-link-a-ref"
              >
                {{ subitem.name }}
                <span class="menu-arrow"></span>
              </a>
              <router-link
                v-if="!hasItems(subitem)"
                tag="a"
                :to="`${item.path}/${subitem.path}`"
                class="side-nav-link-ref"
                >{{ subitem.name.replaceAll('_', '') }}</router-link
              >

              <ul
                v-if="hasItems(subitem)"
                class="nav-third-level"
                aria-expanded="false"
              >
                <li
                  v-for="subSubitem in subitem.children"
                  :key="`sub-sub-item-${subSubitem.name}`"
                >
                  <router-link
                    tag="a"
                    :to="`${item.path}/${subitem.path}/${subSubitem.path}`"
                    class="side-nav-link-ref"
                    >{{ subSubitem.name }}</router-link
                  >
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </li>
    </template>
    <li class="side-nav-title side-nav-item">
      <p class="menu-title mb-0">Support</p>
      <router-link
        tag="a"
        :to="{ name: 'Support' }"
        class="side-nav-link side-nav-link-ref"
      >
        <i class="mr-2 uil uil-question-circle"></i>
        <span>API & Doc</span>
      </router-link>
    </li>
  </ul>
  <!-- End Sidebar -->
</template>
